import { useMutation } from "@tanstack/react-query";
import customFieldGroupService from "../api/customFieldGroupService";

export const useUpdateGroupVisibility = () => {
  const { updateGroupVisibility } = customFieldGroupService();

  return useMutation({
    mutationKey: ["update-group-visibility"],
    mutationFn: async ({ visibility }) => {
      const response = await updateGroupVisibility(visibility);
      return response.data;
    },
  });
};

export const useCreateOrUpdateCustomFieldGroup = () => {
  const { createOrUpdateCustomFieldGroup } = customFieldGroupService();

  return useMutation({
    mutationKey: ["create-or-update-custom-field-group"],
    mutationFn: async ({ customFieldGroup }) => {
      const response = await createOrUpdateCustomFieldGroup(customFieldGroup);
      return response.data;
    },
  });
};

export const useDeleteCustomFieldGroup = () => {
  const { deleteCustomFieldGroup } = customFieldGroupService();

  return useMutation({
    mutationKey: ["delete-custom-field-group"],
    mutationFn: async ({ id }) => {
      const response = await deleteCustomFieldGroup(id);
      return response.data;
    },
  });
};
